import { Link } from '@reach/router';
import * as React from 'react';
import { CustomComponentWrap, MultiColumn, Translate } from '../../components';
import { ContentfulPost } from '../../interfaces';
import { calculateSrcset, fixContentfulAssetPath, localizeLink } from '../../utils';

export const CarouselPostTemplate = ({
  items: [post],
  path,
}: {
  items: ContentfulPost[];
  path: string;
}) => (
  <CustomComponentWrap className={['box-shadow']} style={{ backgroundColor: '#fff' }}>
    <MultiColumn imagecrop="375px" breakOnTablet spaceDistribution="2,1" gap="25px">
      {post.heroImage && (
        <Link to={localizeLink(post.fields.locale, `/${path}/${post.slug}`)}>
          <img
            alt={post.heroImage.title}
            src={fixContentfulAssetPath(post.heroImage.file.url)}
            srcSet={calculateSrcset(post.heroImage.file.url, 1000)}
          />
        </Link>
      )}
      <div className="padding-small">
        {post.title && <h3>{post.title}</h3>}
        {post.excerpt && <p>{post.excerpt}</p>}
        <Link to={localizeLink(post.fields.locale, `/${path}/${post.slug}`)}>
          <Translate id="component.readMore" />
        </Link>
      </div>
    </MultiColumn>
  </CustomComponentWrap>
);
